module.exports = __webpack_public_path__ + "img/stock2.8788f5d9.png";